<formio
  #formView
  [form]="form"
  [submission]="submission"
  [readOnly]="true"
  [viewOnly]="true"
  (ready)="onReady($event)"
  (change)="onChange($event)">
</formio>